import React from "react";
import { Link } from "react-router-dom";
import copyrightsvg from "../icons/copyright-ico.svg";
import "./CopyRights.css";

const CopyRight = () => {
  return (
    <div className="copyright-div">
      <div className="copyright-title-div">
        <img src={copyrightsvg} alt="copyright-icon" />
        <div className="latest-title">Copyright Notice</div>
      </div>

      <div className="copyright-content">
        All content, images, videos, and materials on this website are the
        property of Yasiru Panduka. Unauthorized use, reproduction, or
        distribution of any content without prior written permission is strictly
        prohibited and may be subject to legal action.
      </div>

      <div className="copyright-contact">
        <div className="copyright-contact-info">
          For inquiries or permission requests, please contact:
        </div>
        <div className="copyright-contact-mail">
          Email: <Link to="mailto: yasirupanduka.penta@gmail.com">yasirupanduka.penta@gmail.com</Link>
        </div>
      </div>
    </div>
  );
};

export default CopyRight;
